import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';
import SharedLink from '../../../../../shared/Link/Link';

export type LinkProps = {
  to?: string;
  target?: string;
  download?: boolean;
  label?: string | null;
  children?: ReactNode;
};

export const StyledLink = styled(SharedLink)`
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles.elements.link)}
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.vStyles.elements.link)}
`;

export const Link = ({ to, target, download, label, children }: LinkProps) => (
  <StyledLink to={to} target={target} download={download} label={label}>
    {children}
  </StyledLink>
);
